<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                </b-card>

                <b-card>
                    <div v-if="flag">
                        <div class="row mb-2">
                            <div v-if="trainee_id" class="col-md-12">
                                <form action="">
                                    <div class="form-row">
                                        <div class="form-group col-md-5 col-sm-5 col-lg-5">
                                            <select v-model="form_no" v-validate="'required'" id="form_no" name="form_no" class="form-control form-control-sm">
                                                <option :value="''">Select One</option>
                                                <option v-if="trainee_followup_check === null" value="01">Initial</option>
                                                <option value="02">Second</option>
                                                <option v-if="trainee_followup_last_check === null" value="999">Last</option>
                                            </select>
                                            <div class="invalid-feedback">
                                                Please Select Step.
                                            </div>
                                        </div>
                                        <div class="form-group col-md-3 col-sm-3 col-lg-3">
                                            <button class="btn btn-success btn-sm waves-effect waves-light" @click.prevent="create">Create</button>
                                        </div>
                                        <div class="form-group col-md-4 col-sm-4 col-lg-4">
                                            <router-link
                                                    :to="{name: 'followupDocCreate',params: { trainee_id: trainee_id }}"
                                                    tag="a"
                                                    class="btn btn-sm btn-success float-right" title="Trainee Followup Doc">Followup Doc
                                            </router-link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div v-if="trainee_followups.length > 0" class="mt-4">
                        <h4>Training Before</h4>
                    </div>
                    <div v-if="trainee_followups.length > 0" class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>SL</th>
                                <th>Question 1</th>
                                <th>Question 2</th>
                                <th>Question 3</th>
                                <th>Date</th>
                                <th>Remarks</th>
                                <th>Option</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr  v-for="(trainee_followup, index) in trainee_followups" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ trainee_followup.question_1 }}</td>
                                <td>{{ trainee_followup.question_2 }}</td>
                                <td>{{ trainee_followup.question_3 }}</td>
                                <td>{{ trainee_followup.date }}</td>
                                <td>{{ trainee_followup.remarks }}</td>
                                <td>
                                    <router-link
                                            :to="{name: 'computerBasicFollowupEdit',params: { followup_id: trainee_followup.id }}"
                                            tag="a"
                                            class="action-icon" title="Trainee Followup Update"
                                            target="_blank">
                                        <i class="mdi mdi-square-edit-outline editButton"></i>
                                    </router-link>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-if="trainee_followup_seconds.length > 0" class="mt-4">
                        <h4>Training Second </h4>
                    </div>
                    <div v-if="trainee_followup_seconds.length > 0" class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>SL</th>
                                <th>Question 1</th>
                                <th>Question 2</th>
                                <th>Question 3</th>
                                <th>Date</th>
                                <th>Remarks</th>
                                <th>Option</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr  v-for="(trainee_followup_second, index) in trainee_followup_seconds" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ trainee_followup_second.question_1 }}</td>
                                <td>{{ trainee_followup_second.question_2 }}</td>
                                <td>{{ trainee_followup_second.question_3 }}</td>
                                <td>{{ trainee_followup_second.date }}</td>
                                <td>{{ trainee_followup_second.remarks }}</td>
                                <td>
                                    <router-link
                                            :to="{name: 'computerBasicFollowupSecondEdit',params: { followup_id: trainee_followup_second.id }}"
                                            tag="a"
                                            class="action-icon" title="Trainee Followup Second Update"
                                            target="_blank">
                                        <i class="mdi mdi-square-edit-outline editButton"></i>
                                    </router-link>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-if="trainee_followup_lasts.length > 0" class="mt-4">
                        <h4>Training Last </h4>
                    </div>
                    <div v-if="trainee_followup_lasts.length > 0" class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>SL</th>
                                <th>Question 1</th>
                                <th>Question 2</th>
                                <th>Question 3</th>
                                <th>Date</th>
                                <th>Remarks</th>
                                <th>Option</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr  v-for="(trainee_followup_last, index) in trainee_followup_lasts" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ trainee_followup_last.question_1 }}</td>
                                <td>{{ trainee_followup_last.question_2 }}</td>
                                <td>{{ trainee_followup_last.question_3 }}</td>
                                <td>{{ trainee_followup_last.date }}</td>
                                <td>{{ trainee_followup_last.remarks }}</td>
                                <td>
                                    <router-link
                                            :to="{name: 'computerBasicFollowupLastEdit',params: { followup_id: trainee_followup_last.id }}"
                                            tag="a"
                                            class="action-icon" title="Trainee Followup Last Update"
                                            target="_blank">
                                        <i class="mdi mdi-square-edit-outline editButton"></i>
                                    </router-link>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-if="trainee_followup_docs.length > 0" class="mt-4">
                        <h4>Training Followup Docs </h4>
                    </div>
                    <div v-if="trainee_followup_docs.length > 0" class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>SL</th>
                                <th>Caption</th>
                                <th>File</th>
                                <th>Remarks</th>
                                <th>Option</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr  v-for="(trainee_followup_doc, index) in trainee_followup_docs" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ trainee_followup_doc.caption }}</td>
                                <td>
                                    <a :href="trainee_followup_doc.name" target="_blank">
                                        <img :src="trainee_followup_doc.name" alt="" class="rounded-circle" height="30px" width="30px"/>
                                    </a>
                                </td>
                                <td>{{ trainee_followup_doc.remarks }}</td>
                                <td>
                                    <router-link
                                            :to="{name: 'followupDocEdit',params: { followup_doc_id: trainee_followup_doc.id }}"
                                            tag="a"
                                            class="action-icon" title="Trainee Followup File Update"
                                            >
                                        <i class="mdi mdi-square-edit-outline editButton"></i>
                                    </router-link>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    export default {
        page: {
            title: "Trainee Followup List",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {Layout, PageHeader },
        data() {
            return {
                title: "Trainee Followup",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Trainee",
                        active: true
                    }
                ],
                flag: false,
                trainee_id: '',
                trainee_followup_check: '',
                trainee_followup_last_check: '',
                trainee_followups: [],
                trainee_followup_seconds: [],
                trainee_followup_lasts: [],
                trainee_followup_docs: [],
                form_no: '',
            };
        },


        mounted() {
            this.trainee_id = this.$route.params.trainee_id;
            this.traineeFollowupCheck();
            this.traineeFollowupLastCheck();
            this.getTraineeFollowup();
            this.getTraineeFollowupSecond();
            this.getTraineeFollowupLast();
            this.getTraineeFollowupDoc();
        },
        methods: {
            async getTraineeFollowup() {
                await http.get("api/trainee/computer-basic/followup/list/" + this.trainee_id)
                    .then(resource => {
                        this.trainee_followups = resource.data.trainee_followups
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            async getTraineeFollowupSecond() {
                await http.get("api/trainee/computer-basic/followup-second/list/" + this.trainee_id)
                    .then(resource => {
                        this.trainee_followup_seconds = resource.data.trainee_followup_seconds
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            async getTraineeFollowupLast() {
                await http.get("api/trainee/computer-basic/followup_last/list/" + this.trainee_id)
                    .then(resource => {
                        this.trainee_followup_lasts = resource.data.trainee_followup_lasts
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            async getTraineeFollowupDoc() {
                await http.get("api/trainee/followup-doc/list/" + this.trainee_id)
                    .then(resource => {
                        this.trainee_followup_docs = resource.data.trainee_followup_docs
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            async traineeFollowupCheck() {
                await http.get("api/trainee/computer-basic/followup/check/" + this.trainee_id)
                    .then(resource => {
                        this.flag = true;
                        this.trainee_followup_check = resource.data.trainee_followup_check

                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            async traineeFollowupLastCheck() {
                await http.get("api/trainee/computer-basic/followup_last/check/" + this.trainee_id)
                    .then(resource => {
                        this.flag = true;
                        this.trainee_followup_last_check = resource.data.trainee_followup_last_check

                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            async create() {
                await this.$validator.validate().then(valid => {
                    if (valid) {
                        if (this.form_no === '01'){
                            this.$router.push({path:'/trainee/computer-basic/followup/create/' + this.trainee_id + '/' + this.form_no})
                        }
                        if (this.form_no === '02'){
                            this.$router.push({path:'/trainee/computer-basic/followup-second/create/' + this.trainee_id + '/' + this.form_no})
                        }
                        if (this.form_no === '999'){
                            this.$router.push({path:'/trainee/computer-basic/followup_last/create/' + this.trainee_id + '/' + this.form_no})
                        }
                    }
                });
            },
        },
    };
</script>
